import {StyledTableView} from 'src/features/admin-host-approval/components/table-view/style.ts'
import {HTMLAttributes} from 'react'

export const TableView = (props: HTMLAttributes<HTMLDivElement>) => <StyledTableView {...props} />
